import { ChangeDetectorRef, Component, ComponentFactoryResolver, ComponentRef, Injector, Input, OnInit, TemplateRef, Type, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { DialogService, DialogTemplateResult } from '../dialog.service';
import { GlobalsService } from '../globals.service';
import { NavigateService } from '../navigate.service';
import { UtilService } from '../util.service';

@Component({
  selector: 'app-popover',
  templateUrl: './popover.component.html',
  styleUrls: ['./popover.component.scss'],
  providers: [{
    provide: 'ID_GENERATOR_BASE',
    useFactory: (self: PopoverComponent, go: NavigateService, util: UtilService) => {
      return util.onlyAlphanumeric(go.getStackRouteUrl());
    },
    deps: [PopoverComponent, NavigateService, UtilService]
  }]
})
export class PopoverComponent implements OnInit {
  @ViewChild('body', { read: ViewContainerRef }) body?: ViewContainerRef;
  @Input() set title(value: string) {
    if(this._title != value)  {
      this._title = value;
      this.cdRef.detectChanges();
    }
  };
  get title(): string {
    return this._title;
  }

  public id: string;
  public route?: ActivatedRouteSnapshot;
  public popoverBodyRef?: ComponentRef<Type<any>>;
  public componentRef?: ComponentRef<PopoverComponent>;
  public dialogs?: DialogService;
  public template?: TemplateRef<any>;
  public icon?: string;
  public target?: HTMLElement;
  public popover?: bootstrap.Popover;
  public templateContext: any;
  public templateResult?: Promise<DialogTemplateResult>;
  public closing: boolean = false;

  private _factory?: ComponentFactoryResolver;
  public get factory(): ComponentFactoryResolver { this._factory = this._factory || this.injector.get<ComponentFactoryResolver>(ComponentFactoryResolver); return this._factory }
  private _cdRef?: ChangeDetectorRef;
  public get cdRef(): ChangeDetectorRef { this._cdRef = this._cdRef || this.injector.get<ChangeDetectorRef>(ChangeDetectorRef); return this._cdRef }
  private _go?: NavigateService;
  public get go(): NavigateService { this._go = this._go || this.injector.get<NavigateService>(NavigateService); return this._go }
  private _gb?: GlobalsService;
  public get gb(): GlobalsService { this._gb = this._gb || this.injector.get<GlobalsService>(GlobalsService); return this._gb }

  private _title: string = "";

  constructor(public injector: Injector) {
    this.id = 'popover' + (new Date().getTime());
  }

  ngOnInit(): void {
  }

  public hide() {
    this.closing = true;
    this.popover!.dispose();
  }

  public show() {
    let self = this;
    this.dialogs!.popoverShowing = this;
    this.cdRef.detectChanges();
    //@ts-ignore
    this.popover = new bootstrap.Popover(this.target!, {
      html: true,
      title: this.title,
      content: $("#" + this.id)
    });
    this.popover.show();
    this.target!.addEventListener('hidden.bs.popover', () => {
      if(!self.closing) {
        self.dialogs!.popoverShowing = undefined;
        self.componentRef?.destroy();
      }
    })
  }

  public ngAfterViewInit() {
    if(this.route && this.route.component) {
      const componentType = this.route.component as Type<any>;
      const componentFactory = this.factory.resolveComponentFactory(componentType);
      if(this.route.data.title?.length) this.title = this.route.data.title;
      this.popoverBodyRef = this.body!.createComponent<typeof componentType>(componentFactory);
    }
    this.show();
  }
}
